import { ProgressIndicator, Text } from '@fluentui/react'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import { ConnectedRouter } from 'connected-react-router'
import { reactPlugin } from 'global/Application/AppInsight'
import ApplicationContextProvider from 'global/Application/Context'
import { useAuthentication } from "global/Authentication"
import Debugger from 'global/Debugger'
import { Suspense } from 'react'
import { Route, Switch } from "react-router-dom"
import AccountsReceivable from 'views/BlueRelationship/AccountsReceivable'
import Benefit from 'views/BlueRelationship/Benefit'
import BlueRelationship from 'views/BlueRelationship/BlueRelationship'
import CheckList from 'views/BlueRelationship/CheckList/CheckList'
import CheckListItem from 'views/BlueRelationship/CheckList/CheckListItem/CheckListItem'
import FeesAndPremium from 'views/BlueRelationship/FeesAndPremium'
import Finished from 'views/BlueRelationship/Fnished'
import StopLoss from 'views/BlueRelationship/StopLoss'
import Timeline from 'views/BlueRelationship/Timeline'
import { history } from './app/store'
import { AutoSwitchLayout } from './components/layout'
import { ComingSoon, NoMatch } from "./components/route"
import { ErrorBoundary } from "./global/ErrorBoundary"
import GroupConfiguration from './views/BlueRelationship/GroupConfiguration'
import Plan from './views/BlueRelationship/Plan'
import ComparisonTool from "./views/Comparison/ComparisonTool"
import LoadGroupHeaders from "./views/Comparison/LoadGroupHeaders"
import PharmacyLanding from "./views/Comparison/PharmacyLanding"
import PharmacyTool from "./views/Comparison/PharmacyTool"
import SubgroupInformation from "./views/Comparison/SubgroupInformationReport"
import Dashboard from './views/Dashboard'
import Login from './views/Login'
import Redirect from './views/Redirect'
import Stencil from './views/Stencil'
import QuoteRequest from 'views/QuoteRequest'
import NonStandardTemplates from './views/BlueRelationship/NonStandardTemplates'

export interface RouterParams {

    // TODO rename this to accountId
    id?: string;
    snapshotId?: string;
    planId?: string;
    benefitId?: string;
    tabId?: string;
    sectionId?: string;
    fieldId?: string;
    nonStandardId?: string;
    groupNumberId?: string;
    flexibleFieldSetId?: string;
    feesAndPremiumId?: string;
    stopLossId?: string;
    snapshot1?: string;
    snapshot2?: string;
    claimsARId?: string;
    plan1?: string;

    tab2ndId?: string;
    section2ndId?: string;
    field2ndId?: string;

    bcbs_emchecklistid?: string;

    bcbs_opportunityproductid?: string;
    bcbs_opportunityoptionid?: string;
}


const App = () => {
    const { isAuthenticated, authorizations } = useAuthentication();

    const renderWithLayout = (Component: any) => (props: any) => (
        <AutoSwitchLayout {...props}>
            {authorizations?.roles['BCBS - Power User'] &&
                <Debugger />
            }
            <Component
                {...props}
            />
        </AutoSwitchLayout>
    );
    const renderCompareBoundaryWithLayout = (Component: any) => (props: any) => (
        <AutoSwitchLayout {...props}>
            <ErrorBoundary>
                <Component
                    {...props}
                />
            </ErrorBoundary>
        </AutoSwitchLayout>
    );

    const blueRelationshipRoute = `/records/blueRelationship/:id`;
    const group = `${blueRelationshipRoute}/groupConfiguration/:snapshotId`;
    const plan = `/plan/:planId`;
    const rootRoute = `/root/:X`;
    const benefit = `/benefit/:benefitId`;
    const tab = `/tab/:tabId`;
    const section = `/section/:sectionId`;
    const field = `/field/:fieldId`;
    const feesAndPremium = `/feesAndPremium/:feesAndPremiumId`;
    const stopLoss = `/stopLoss/:stopLossId`;
    const groupNumber = `/groupNumber/:groupNumberId`;
    const accountsReceivable = `/claimsAR/:claimsARId`;
    const nonstandardRoute = `/nonStandard/:nonStandardId`;
    const flexibleFieldSetRoute = `/flexibleFieldSet/:flexibleFieldSetId`;

    const checklistRoute = `/checklist`;



    const tab2nd = `/tab/:tab2ndId`;
    const section2nd = `/section/:section2ndId`;
    const field2nd = `/field/:field2ndId`;

    return (
        <ConnectedRouter history={history}>
            <ApplicationContextProvider>
                <Suspense fallback={<ProgressIndicator label="Page loading..." />}>
                    <Switch>
                        <Route path="/redirect" component={Redirect} />
                        <Route path="/login" component={renderWithLayout(Login)} />
                        <Route
                            path="/"
                            exact
                            component={isAuthenticated ? renderWithLayout(Dashboard) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/profile"
                            exact
                            component={isAuthenticated ? renderWithLayout(ComingSoon) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/management"
                            exact
                            component={isAuthenticated ? renderWithLayout(ComingSoon) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/management/timeline"
                            exact
                            component={isAuthenticated ? renderWithLayout(ComingSoon) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/management/settings"
                            exact
                            component={isAuthenticated ? renderWithLayout(ComingSoon) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/subgroupInformation/:id/:snapshotId/"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(SubgroupInformation) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/pharmacyLanding/:id/:snapshot1/:snapshot2"
                            exact
                            component={isAuthenticated ? renderWithLayout(PharmacyLanding) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/pharmacyLanding/:id/:snapshot1/"
                            exact
                            component={isAuthenticated ? renderWithLayout(PharmacyLanding) : renderWithLayout(Login)}
                        />

                        <Route
                            path="/pharmacy/:id/:snapshot1/:plan1"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(PharmacyTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/pharmacy/:id/:snapshot1/:plan1/:snapshot2"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(PharmacyTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/groupHeaders/:id/:snapshotId/:planId"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(LoadGroupHeaders) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/comparison/:id/:snapshot1/:snapshot2"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/comparison/:id/:snapshot2"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/comparison/:id"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/underwritingReview/:id/:snapshot1/:snapshot2"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/underwritingReview/:id/:snapshot2/"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/merge/:id"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/merge/:id/:snapshot1"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/merge/:id/:snapshot1/:snapshot2"
                            exact
                            component={isAuthenticated ? renderCompareBoundaryWithLayout(ComparisonTool) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/records/blueRelationship"
                            exact
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path="/records/contacts"
                            exact
                            component={isAuthenticated ? renderWithLayout(ComingSoon) : renderWithLayout(Login)}
                        />

                        <Route
                            path={group + checklistRoute + '/list'}
                            component={isAuthenticated ? renderWithLayout(CheckList) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + checklistRoute + "/:bcbs_emchecklistid"}
                            component={isAuthenticated ? renderWithLayout(CheckListItem) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + '/nonstandardtemplates'}
                            component={isAuthenticated ? renderWithLayout(NonStandardTemplates) : renderWithLayout(Login)}
                        />

                        <Route
                            path={group + groupNumber + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + groupNumber + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + groupNumber + tab2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + groupNumber}
                            exact
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />


                        <Route
                            path={group + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + flexibleFieldSetRoute}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + nonstandardRoute}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section + field}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab + section}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + tab}
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group}
                            exact
                            component={isAuthenticated ? renderWithLayout(GroupConfiguration) : renderWithLayout(Login)}
                        />

                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + flexibleFieldSetRoute}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + nonstandardRoute}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section + field}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab + section}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan + tab}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + plan}
                            component={isAuthenticated ? renderWithLayout(Plan) : renderWithLayout(Login)}
                        />

                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + flexibleFieldSetRoute}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + nonstandardRoute}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section + field}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab + section}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit + tab}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + benefit}
                            component={isAuthenticated ? renderWithLayout(Benefit) : renderWithLayout(Login)}
                        />



                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + flexibleFieldSetRoute}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + stopLoss + tab + section + field}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + stopLoss + tab + section}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + stopLoss + tab}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + stopLoss}
                            component={isAuthenticated ? renderWithLayout(StopLoss) : renderWithLayout(Login)}
                        />


                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + flexibleFieldSetRoute}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section + field}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + feesAndPremium + tab + section}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + feesAndPremium + tab}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + feesAndPremium}
                            component={isAuthenticated ? renderWithLayout(FeesAndPremium) : renderWithLayout(Login)}
                        />



                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute + tab2nd + section2nd + field2nd}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute + tab2nd + section2nd}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute + tab2nd}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + flexibleFieldSetRoute}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section + field}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + accountsReceivable + tab + section}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + accountsReceivable + tab}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />
                        <Route
                            path={group + accountsReceivable}
                            component={isAuthenticated ? renderWithLayout(AccountsReceivable) : renderWithLayout(Login)}
                        />

                        <Route
                            path={'/bcbs_opportunityproduct/:bcbs_opportunityproductid/bcbs_opportunityoption/:bcbs_opportunityoptionid'}
                            exact
                            component={isAuthenticated ? renderWithLayout(QuoteRequest) : renderWithLayout(Login)}
                        />

                        <Route
                            path={'/bcbs_opportunityproduct/:bcbs_opportunityproductid'}
                            exact
                            component={isAuthenticated ? renderWithLayout(QuoteRequest) : renderWithLayout(Login)}
                        />


                        <Route
                            path={group + '/timeline'}
                            exact
                            component={isAuthenticated ? renderWithLayout(Timeline) : renderWithLayout(Login)}
                        />

                        <Route
                            path={'/debug'}
                            component={renderWithLayout(Debugger)}
                        />

                        <Route
                            path={'/finished'}
                            exact
                            component={renderWithLayout(Finished)}
                        />

                        <Route
                            path={blueRelationshipRoute}
                            exact
                            component={isAuthenticated ? renderWithLayout(BlueRelationship) : renderWithLayout(Login)}
                        />

                        <Route
                            path={'/stencil'}
                            exact
                            component={Stencil}
                        />

                        <Route
                            path="*"
                            component={renderWithLayout(NoMatch)}
                        />
                    </Switch>
                </Suspense>
            </ApplicationContextProvider>
        </ConnectedRouter>
    );
}

export default withAITracking(reactPlugin, App);